"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dashToCamel = void 0;
/**
 * Convert dashed strings into camelCase
 * e.g. foo-bar becomes fooBar
 * @param {string} str String that containes hyphens
 * @returns {string}
 */
var dashToCamel = function (str) {
    return str.replace(/-(\w)/g, function (_, up) { return up.toUpperCase(); });
};
exports.dashToCamel = dashToCamel;
